import authenticationConstants from 'components/Authentication/constants';
import { SET_KEY_VALUE, UNSET_KEY_VALUE, UPDATE_KEY_VALUE } from './actionTypes';

const { LOGOUT } = authenticationConstants;

const initialState = {};

// eslint-disable-next-line default-param-last
export function keyValueStore(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_KEY_VALUE: {
      const { key, data } = payload;
      return { ...state, [key]: data };
    }
    case UPDATE_KEY_VALUE: {
      const { key, data: dataToUpdate } = payload;
      const { [key]: currentData } = state;
      // only object data type is supported
      return { ...state, [key]: { ...currentData ?? {}, ...dataToUpdate } };
    }
    case UNSET_KEY_VALUE: {
      const { [payload]: key, ...rest } = state;
      return rest;
    }
    case LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
}
